import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'app/store'
import { userDataActionCreators } from 'app/store/actions/user-data.actions'
import { LOCAL_STORAGE_KEYS } from 'app/constants/local-storage.constant'
import EntitlementService from 'app/services/core/entitlement.service'
import useReadOnly from 'app/hooks/use-read-only.hook'

export default function useCorrectGrade() {
  const dispatch = useAppDispatch()
  const {
    grades,
    grade,
    kcInfo: { isTeacher },
  } = useAppSelector((state) => state.userData)

  const isReadOnly = useReadOnly()

  useEffect(() => {
    if (!grades.length) return

    if (grade && grades.includes(grade)) {
      try {
        localStorage.setItem(LOCAL_STORAGE_KEYS.GRADE, grade)
      } catch (e) {
        console.error(e)
      }
    } else if (grades.length >= 2) {
      const defaultGrade = EntitlementService.getDefaultGrade(grades)
      dispatch(
        userDataActionCreators.setUserGrade.request({
          grade: defaultGrade,
          isReadOnly,
        })
      )
    } else if (grades.length === 1) {
      dispatch(
        userDataActionCreators.setUserGrade.request({
          grade: grades[0],
          isReadOnly,
        })
      )
    }
  }, [grades, grade, isTeacher, isReadOnly, dispatch])
}
